import {
  LESSON_VIEWER_FETCH_START,
  LESSON_VIEWER_FETCH_SUCCESS,
  LESSON_VIEWER_FETCH_ERROR,
  LESSON_VIEWER_RESET,
  LESSON_VIEWER_SET_PHASE,
  LESSON_VIEWER_ADVANCE_TERM,
  LESSON_VIEWER_SET_QUESTION_INDEX,
  LESSON_VIEWER_WORKBOOK_READY,
  LESSON_VIEWER_WORKBOOK_DONE,
  LESSON_VIEWER_WORKBOOK_SUBMIT,
  LESSON_VIEWER_KC_SUBMIT,
  LESSON_VIEWER_KC_NEXT,
  LESSON_VIEWER_KC_SUMMARY_DONE,
  LESSON_VIEWER_MASTERY_SUBMIT,
  LESSON_VIEWER_MASTERY_NEXT,
  LESSON_VIEWER_TOGGLE_DEV_TOOLS,
  LESSON_VIEWER_SET_TUTORIAL_VIEWED,
  LESSON_VIEWER_SET_TUTOR_CHAT_OPEN,
} from './actionTypes';

const TERM_RESET_FIELDS = {
  workbookReady: false,
  workbookDone: false,
  workbookSubmitted: false,
  workbookSelectedOption: null,
  kcAnswers: [],
  kcComplete: false,
  activeQuestionIndex: 0,
};

export const initialState = {
  loading: false,
  error: null,
  rawPayload: null,
  viewerModel: null,

  phase: 'tutorial',
  activeTermIndex: 0,
  activeQuestionIndex: 0,

  workbookReady: false,
  workbookDone: false,
  workbookSubmitted: false,
  workbookSelectedOption: null,

  kcAnswers: [],
  kcComplete: false,

  masteryAnswers: [],
  masteryComplete: false,

  showDevTools: true,
  tutorialViewed: false,
  tutorChatOpen: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LESSON_VIEWER_FETCH_START:
      return {...state, loading: true, error: null};

    case LESSON_VIEWER_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        rawPayload: action.payload.rawPayload,
        viewerModel: action.payload.viewerModel,
        tutorialViewed: action.payload.tutorialViewed || false,
        phase: action.payload.tutorialViewed ? 'frontloading' : 'tutorial',
      };

    case LESSON_VIEWER_FETCH_ERROR:
      return {...state, loading: false, error: action.payload};

    case LESSON_VIEWER_RESET:
      return {...initialState};

    case LESSON_VIEWER_SET_PHASE:
      return {...state, phase: action.payload, tutorChatOpen: false};

    case LESSON_VIEWER_ADVANCE_TERM:
      return {
        ...state,
        activeTermIndex: action.payload,
        phase: 'learning',
        ...TERM_RESET_FIELDS,
        tutorChatOpen: false,
      };

    case LESSON_VIEWER_SET_QUESTION_INDEX:
      return {...state, activeQuestionIndex: action.payload};

    case LESSON_VIEWER_WORKBOOK_READY:
      return {...state, workbookReady: true};

    case LESSON_VIEWER_WORKBOOK_DONE:
      return {...state, workbookDone: true, phase: 'workbook_options'};

    case LESSON_VIEWER_WORKBOOK_SUBMIT:
      return {
        ...state,
        workbookSubmitted: true,
        workbookSelectedOption: action.payload.optionIndex,
      };

    case LESSON_VIEWER_KC_SUBMIT:
      return {
        ...state,
        kcAnswers: [
          ...state.kcAnswers,
          {
            questionIndex: action.payload.questionIndex,
            selectedAnswer: action.payload.selectedAnswer,
            correct: action.payload.correct,
          },
        ],
      };

    case LESSON_VIEWER_KC_NEXT:
      return {
        ...state,
        activeQuestionIndex: state.activeQuestionIndex + 1,
      };

    case LESSON_VIEWER_KC_SUMMARY_DONE: {
      const totalTerms = state.viewerModel?.terms?.length || 0;
      const nextTermIndex = state.activeTermIndex + 1;
      if (nextTermIndex < totalTerms) {
        return {
          ...state,
          activeTermIndex: nextTermIndex,
          phase: 'learning',
          ...TERM_RESET_FIELDS,
          tutorChatOpen: false,
        };
      }
      return {
        ...state,
        phase: 'mastery',
        activeQuestionIndex: 0,
        masteryAnswers: [],
        masteryComplete: false,
        tutorChatOpen: false,
      };
    }

    case LESSON_VIEWER_MASTERY_SUBMIT:
      return {
        ...state,
        masteryAnswers: [
          ...state.masteryAnswers,
          {
            questionIndex: action.payload.questionIndex,
            selectedAnswer: action.payload.selectedAnswer,
            correct: action.payload.correct,
          },
        ],
      };

    case LESSON_VIEWER_MASTERY_NEXT: {
      const masteryQuestions =
        state.viewerModel?.mastery?.questions || [];
      const nextIdx = state.activeQuestionIndex + 1;
      if (nextIdx < masteryQuestions.length) {
        return {...state, activeQuestionIndex: nextIdx};
      }
      return {
        ...state,
        masteryComplete: true,
        phase: 'results',
        tutorChatOpen: false,
      };
    }

    case LESSON_VIEWER_TOGGLE_DEV_TOOLS:
      return {...state, showDevTools: !state.showDevTools};

    case LESSON_VIEWER_SET_TUTORIAL_VIEWED:
      return {...state, tutorialViewed: true, phase: 'frontloading'};

    case LESSON_VIEWER_SET_TUTOR_CHAT_OPEN:
      return {...state, tutorChatOpen: action.payload};

    default:
      return state;
  }
};

export default reducer;
